export { default as UpdateGlobalCompanyTabForm } from './UpdateGlobalCompanyTabForm';
